import {LottieView} from '@eCommerce/frontend-legacy-shared-library';
import {StatusType} from 'models/StatusTypes';
import {Box, Text, View} from 'native-base';
import {IViewProps} from 'native-base/lib/typescript/components/basic/View/types';
import React, {ReactElement} from 'react';
import {getOverlayAnimation} from 'utils/getOverlayAnimation';

export interface StatusDisplayProps extends IViewProps {
  titleText: string;
  upperDescriptionText?: string | ReactElement;
  statusType: StatusType;
  lowerDescriptionText?: string | ReactElement;
  children?: React.ReactElement;
}

const StatusDisplay: React.FC<StatusDisplayProps> = ({
  titleText,
  upperDescriptionText,
  lowerDescriptionText,
  statusType,
  children,
  ...rest
}) => {
  return (
    <View
      justifyContent="center"
      alignItems="center"
      bgColor="ghostWhite"
      overflow="hidden"
      flex={1}
      paddingX="40px"
      paddingY="30px"
      borderRadius="4px"
      style={{
        shadowColor: '#000',
        shadowOffset: {height: 1, width: 0},
        shadowOpacity: 0.1,
        shadowRadius: 3,
        elevation: 2,
      }}
      {...rest}
    >
      <Box justifyContent="center" alignItems="center">
        <LottieView
          source={getOverlayAnimation(statusType)}
          style={{height: 64, width: 64}}
          loop={statusType === StatusType.LOADING}
          autoPlay={true}
        />
        <Text
          textAlign="center"
          fontFamily="heading"
          fontWeight="700"
          fontSize="22px"
          lineHeight="35px"
          mt="24px"
          mb="16px"
          color="tuna"
        >
          {titleText}
        </Text>
        {upperDescriptionText && (
          <Text
            textAlign="center"
            fontFamily="body"
            fontSize="14px"
            lineHeight="24px"
            color="tuna"
          >
            {upperDescriptionText}
          </Text>
        )}
        {lowerDescriptionText && (
          <Text
            textAlign="center"
            fontFamily="body"
            fontSize="18px"
            lineHeight="30px"
            color="tuna"
          >
            {lowerDescriptionText}
          </Text>
        )}
        {children}
      </Box>
    </View>
  );
};

export default StatusDisplay;
